import { ConstantsLocalApi } from "../constants/ConstantsLocalApi";

export class LocalApiHelper {
    public static GetLocalUrlForEnv(): string {
        // e.g.: /api/env
        return (
            ConstantsLocalApi.LocalUrl +
            ConstantsLocalApi.PartApiPath +
            "/env"
        );
    }
}
